export default __webpack_public_path__ + "static/media/282.0def84cc.jpg";